import { render } from "./SupExpenseList.vue?vue&type=template&id=61b6991b"
import script from "./SupExpenseList.vue?vue&type=script&lang=js"
export * from "./SupExpenseList.vue?vue&type=script&lang=js"

import "./SupExpenseList.vue?vue&type=style&index=0&id=61b6991b&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__